import zhCN from './zh-CN.json'

export default {
  ...zhCN
} as const
